<nav #navbar class="navbar navbar-expand-lg  navbar-absolute fixed-top" id="menuNav">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <i class="fas fa-bars menu-ham" *ngIf="isMobileMenu()" (click)="sidebarToggle()"></i>
      <div class="navbar-minimize" id="hideMenu">
        <button mat-button (click)="minimizeSidebar()">
          <i class="fa-solid fa-angle-left text_align-center visible-on-sidebar-regular menuIcon"
            matTooltip="Nascondi Menu" matTooltipClass="fastlane-tooltip"></i>
          <i class="fa-solid fa-angle-right visible-on-sidebar-mini iconSidebar" matTooltip="Mostra Menu"
            matTooltipClass="fastlane-tooltip"></i>
        </button>
      </div>
      <div *ngIf="!isMobileMenu()" class="navbar-brand"> {{titleAr}} </div>
    </div>
    <div class="justify-content-end" id="navigation">
      <ul class="navbar-nav">
        <li class="nav-item global-supplier-item">
          <app-global-supplier-selector></app-global-supplier-selector>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false" matTooltip="Aggiorna" matTooltipClass="fastlane-tooltip" (click)="refreshPage()">
            <i class="fas fa-sync-alt menuIcon syncIcon"></i>
          </a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false" matTooltip="Utilità" matTooltipClass="fastlane-tooltip">
            <i class="fa-solid fa-screwdriver-wrench menuIcon"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLinkUtilities">
            <a class="dropdown-item " id="user-item-dd">
              <span style="margin: auto;">Utilità</span></a>
            <a class="dropdown-item" href="{{urlLink.fastlaneWiki}}" target="_blank">
              <i class="fas fa-book icon-dd"></i> Manuale utente</a>

            <a class="dropdown-item" (click)="openDialog()" href="javascript:void(0)"><i class="fas fa-rss icon-dd"
                aria-hidden="true"></i>Storico versioni</a>
          </div>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">
            <i class="material-icons menuIcon" matTooltip="Passa a..." matTooltipClass="fastlane-tooltip">apps</i>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLinkPortals">
            <a class="dropdown-item" id="user-item-dd">
              <span style="margin: auto;">Portali</span> </a>
            <a class="dropdown-item" (click)="gotooverview()" matTooltip="Passa a Overview"
              matTooltipClass="fastlane-tooltip" matTooltipPosition="above">
              <img [src]="logoOV" class="img-app" />Overview</a>
            <a class="dropdown-item" (click)="gotoselfnet()" matTooltipClass="fastlane-tooltip"
              matTooltip="Passa a Selfnet">
              <img [src]="logoSN" class="img-app" />Selfnet</a>
          </div>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false" matTooltip="Impostazioni utente" matTooltipClass="fastlane-tooltip">
            <i class="fas fa-user menuIcon"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLinkUser">
            <a class="dropdown-item" id="user-item-dd">
              <i class="fas fa-user-circle user-profile"></i>
              <span style="margin: auto;">{{currentUserName}}</span>
            </a>
            <a class="dropdown-item" id="itemLogout" (click)="signOut()" href="javascript:;"><i
                class="fas fa-sign-out-alt icon-logout" aria-hidden="true"></i>
              Esci</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>